import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import {_printNumber, _printPercent} from '../../helpers/helpers.js'

import {SecurityPageResult} from '../../../../server/routes/security.js'

interface SecurityProps {
	server: string,
    pageData: unknown;
}

export default function Security({pageData}: SecurityProps) {

	let [data, setData] = useState(pageData as SecurityPageResult);

	return (
	<>
		<div className="row row-50 justify-content-xl-between align-items-center flex-md-row-reverse">
			<div className="unit unit-spacing-1 align-items-center">
				{/**     
				<div className="unit-left">
				<div className="icon icon-style-1 mdi mdi-chart-pie"></div>
				</div>
				*/}  
				<div className="unit-body">
				<h3>Vulnerability Scanning</h3>
				<p className="big">Efficiently reduce risk in modern Web Applications</p>                 
				</div>
			</div>
			<div className="col-md-8 col-lg-6 col-xl-6">
				<div className="block-4 offset-top-4">
				<ul className="list-marked list-marked_secondary">
				<li>Accurate vulnerability detection</li>
				<li>Fast and non-intrusive scans (suitable for production environments)</li>
				<li>Detects vulnerable software packages including WordPress themes and plugins</li>                 
				<li>Daily vulnerability database updates</li>
				<li>Reports include software composition analysis</li>
				<li>Automate security scanning with our API</li>
				</ul>
				</div>
			</div>
			<div className="col-md-8 col-lg-6 col-xl-6">
				<div className= "container-fluid">
					<div className= "row justify-content-center">
						<div className= "col-sm-12 col-md-6" style={{textAlign:'center'}}>
							<h3>{_printNumber(data.VulnerabilitiesAddedLastMonth)}</h3>
							<h5 className="counter-classic-title">Vulnerabilities added in the last 30 days</h5>				
						</div>
						<div className= "col-sm-12 col-md-6"  style={{textAlign:'center'}}>
							<h3>{_printNumber(data.TotalVulnerabilities)}</h3>
							<h5 className="counter-classic-title">Total tracked vulnerabilities</h5>
						</div>
					</div>
					<div className= "row justify-content-center">
						<div className= "col-sm-12 col-md-6" style={{textAlign:'center'}}>
							<h3>{_printNumber(data.TotalVulnerableTechnologies)}</h3>
							<h5 className="counter-classic-title">Total tracked vulnerable technologies</h5>
						</div>
						<div className= "col-sm-12 col-md-6" style={{textAlign:'center'}}>
							<h3>{_printNumber(data.TotalVulnerableWebsites)}</h3>
							<h5 className="counter-classic-title">Total discovered vulnerable websites</h5>	
						</div>
					</div>
				</div> 
			</div>
  
			{/**
			<div className="col-md-8 col-lg-5 col-xl-5">
				<div className="block-4 offset-top-4">
				<ul className="list-marked list-marked_secondary">
				<li>Vulnerabilities added in the last month: {_printNumber(data.VulnerabilitiesAddedLastMonth)}</li>
				<li>Total tracked vulnerabilities: {_printNumber(data.TotalVulnerabilities)} </li>
				<li>Total tracked vulnerable technologies: {_printNumber(data.TotalVulnerableTechnologies)}</li>                 
				<li>Total discovered vulnerable websites: {_printNumber(data.TotalVulnerableWebsites)}</li>
				</ul>
				</div>
			</div> 
			*/}
		</div>
		<div className="row row-50 justify-content-xl-between align-items-center flex-md-row-reverse">
{/**			<div className="col-md-7 col-lg-7 col-xl-7"></div>
			<div className="col-md-5 col-lg-5 col-xl-5">			</div>	 */}
				<Link                     
					to={`/cve-security-scan`}
					className="button button-secondary" 
					title={`Scan website`} 
					rel="noopener nofollow" 
				>
					Try free security scan
				</Link>	
		</div>
		<br/>
		<br/>
	</>
	)
};
